module.exports = __webpack_public_path__ + "img/TA@2x.64ad378c.png";